import { FlexColumn, FlexRow } from '@editor/components/utilities/layouts';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const BackgroundImageWrapper = styled.div`
  width: 100%;
  height: min(395px, 100%);
  padding: 20px;
  box-sizing: border-box;
  border-radius: ${themeStyle.radiusLarge};
  background: url('/images/bgFreeTrialCancellation.png') no-repeat center;
  background-size: cover;
`;

export const Content = styled(FlexColumn)`
  padding: 16px 0px;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  height: 100%;
  align-items: center;
  border-radius: ${themeStyle.radiusMedium};
  background-color: #ffffffeb; // 92% opacity

  ${QUERIES.largeTabletAndUp} {
    gap: 24px;
  }
`;

export const FeaturesList = styled(FlexColumn).attrs({ as: 'ul' })`
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;

  ${QUERIES.largeTabletAndUp} {
    gap: 16px;
  }
`;

export const Feature = styled(FlexRow).attrs({ as: 'li' })`
  align-items: center;
  gap: 6px;
`;
